var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnDemandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.27992 8.97978C6.21992 8.97978 6.97325 9.74045 6.97325 10.6871V12.9598C6.97325 13.8998 6.21992 14.6664 5.27992 14.6664H3.02658C2.09325 14.6664 1.33325 13.8998 1.33325 12.9598V10.6871C1.33325 9.74045 2.09325 8.97978 3.02658 8.97978H5.27992ZM12.9733 8.97978C13.9066 8.97978 14.6666 9.74045 14.6666 10.6871V12.9598C14.6666 13.8998 13.9066 14.6664 12.9733 14.6664H10.72C9.77998 14.6664 9.02665 13.8998 9.02665 12.9598V10.6871C9.02665 9.74045 9.77998 8.97978 10.72 8.97978H12.9733ZM5.27992 1.33331C6.21992 1.33331 6.97325 2.09998 6.97325 3.04065V5.31331C6.97325 6.25998 6.21992 7.01998 5.27992 7.01998H3.02658C2.09325 7.01998 1.33325 6.25998 1.33325 5.31331V3.04065C1.33325 2.09998 2.09325 1.33331 3.02658 1.33331H5.27992ZM12.9733 1.33331C13.9066 1.33331 14.6666 2.09998 14.6666 3.04065V5.31331C14.6666 6.25998 13.9066 7.01998 12.9733 7.01998H10.72C9.77998 7.01998 9.02665 6.25998 9.02665 5.31331V3.04065C9.02665 2.09998 9.77998 1.33331 10.72 1.33331H12.9733Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnDemandIcon);
export default __webpack_public_path__ + "static/media/on-demand-icon.476d738c2037ffb9d73ffd6f0c4e83d8.svg";
export { ForwardRef as ReactComponent };